import React from 'react';
import './man-block.css';

export default () => (
  <div className="man-block">
    <div className="man-left-top" />
    <div className="man-left-bottom" />
    <div className="man-right-top" />
    <div className="man-right-bottom" />
  </div>
);



// WEBPACK FOOTER //
// ./src/blocks/VideoBlock/ManBlock/index.js